import { render, staticRenderFns } from "./ProjectQuestionBuilder.vue?vue&type=template&id=5a22e7ca&scoped=true"
import script from "./ProjectQuestionBuilder.vue?vue&type=script&lang=js"
export * from "./ProjectQuestionBuilder.vue?vue&type=script&lang=js"
import style0 from "./ProjectQuestionBuilder.vue?vue&type=style&index=0&id=5a22e7ca&prod&scoped=true&lang=css"
import style1 from "./ProjectQuestionBuilder.vue?vue&type=style&index=1&id=5a22e7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22e7ca",
  null
  
)

export default component.exports